export default __webpack_public_path__ + "static/media/en.28647295.svg";